import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MicExternalOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mic_external_off"}/>
}
